import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GitCompare, ArrowRight, Trash2, FileText } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { Card, PageHeader } from '../components/Card';

export default function MyScenarios() {
  const navigate = useNavigate();
  const { scenarios, setScenarios, showToast } = useApp();

  return (
    <div>
      <PageHeader
        icon={<GitCompare size={22} />}
        title="My Scenarios"
        subtitle="Compare different budget scenarios side by side"
        action={
          <button onClick={() => navigate('/budget')} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            padding: '10px 18px', borderRadius: 'var(--radius-sm)',
            background: 'var(--primary)', color: 'white', border: 'none',
            fontWeight: 500, fontSize: 14,
          }}>
            <ArrowRight size={16} /> Go to Budget Planner
          </button>
        }
      />

      {scenarios.length === 0 ? (
        <Card style={{ textAlign: 'center', padding: 48 }}>
          <FileText size={48} color="var(--gray-300)" style={{ marginBottom: 16 }} />
          <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8, color: 'var(--gray-600)' }}>
            No Scenarios Saved
          </h3>
          <p style={{ color: 'var(--gray-400)', fontSize: 14, marginBottom: 20 }}>
            Go to the Budget Planner and click "Save Scenario" to save your current budget settings for comparison.
          </p>
          <button onClick={() => navigate('/budget')} style={{
            padding: '12px 24px', background: 'var(--primary)', color: 'white',
            borderRadius: 'var(--radius-sm)', fontWeight: 600, fontSize: 14,
          }}>
            Go to Budget Planner
          </button>
        </Card>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
          {scenarios.map(scenario => (
            <Card key={scenario.id} style={{ position: 'relative' }}>
              <button
                onClick={() => {
                  if (window.confirm('Are you sure you want to delete this scenario? This cannot be undone.')) {
                    setScenarios(prev => prev.filter(s => s.id !== scenario.id));
                    showToast('Scenario deleted');
                  }
                }}
                style={{
                  position: 'absolute', top: 12, right: 12,
                  background: 'none', color: 'var(--gray-400)', padding: 4,
                }}
              >
                <Trash2 size={16} />
              </button>
              <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>{scenario.name}</h3>
              <div style={{ fontSize: 12, color: 'var(--gray-500)', marginBottom: 16 }}>
                Saved {new Date(scenario.date).toLocaleDateString()}
              </div>
              {[
                ['Purchase Price', `$${scenario.budget.purchasePrice.toLocaleString()}`],
                ['Down Payment', `$${scenario.downPayment.toLocaleString()} (${scenario.budget.downPaymentPercent}%)`],
                ['Interest Rate', `${scenario.budget.interestRate}%`],
                ['Monthly Payment', `$${scenario.monthlyPayment.toLocaleString()}`],
                ['Total Monthly', `$${scenario.totalMonthlyCost.toLocaleString()}`],
              ].map(([label, val]) => (
                <div key={label} style={{
                  display: 'flex', justifyContent: 'space-between',
                  padding: '6px 0', fontSize: 14, borderBottom: '1px solid var(--gray-100)',
                }}>
                  <span style={{ color: 'var(--gray-600)' }}>{label}</span>
                  <span style={{ fontWeight: 600 }}>{val}</span>
                </div>
              ))}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
